/*
 * 配置编译环境和线上环境之间的切换
 * 以及静态变量
 * baseUrl: 域名地址
 * routerMode: 路由模式
 */
let baseUrl = ''
let routerMode = 'history'
let DEBUG = false
let imagePrefix = 'http://imgs.tenltrs.com/'
if (process.env.NODE_ENV === 'development') { // 测试环境地址
  baseUrl = '/api'
  DEBUG = true
} else if (process.env.NODE_ENV === 'production') { // 生产环境走的地址
  // baseUrl = 'https://api.tenltrs.com/' // 测试地址
  baseUrl = '/api'
  DEBUG = false
} else if (process.env.NODE_ENV === 'testing') { // 测试环境地址
  // baseUrl = 'http://localhost:81/' // 测试地址
  baseUrl = '/api'
  DEBUG = false
}
export default{
  baseUrl,
  routerMode,
  DEBUG,
  imagePrefix
}



// WEBPACK FOOTER //
// ./src/common/env.js